import React from 'react';
import { connect } from 'react-redux';
import UserImage from 'components/Image/UserImage'
import Api from 'api/Api.js';
import { store } from 'redux/store';
import { push } from 'connected-react-router';
import UserEndpoints from 'api/UserEndpoints';
import { SET_ACCOUNT_MANAGERS } from 'redux/types';
import DataTable from '../../../components/Table/DataTable';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Profile",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Name",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Customer Count",
        options: {
            filter: true,
            sort: true,
        }
    }
];

class AccountManagers extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/users/view/' + row[0]))
    };

    UNSAFE_componentWillMount() {
        Api.get(UserEndpoints.accountManagers).then((response) => {
            if (response) {
                var { data } = response;
                store.dispatch({
                    type: SET_ACCOUNT_MANAGERS,
                    payload: data.sort(
                        (a, b) => {
                            if (a.accounts_managed > b.accounts_managed) {
                                return -1;
                            }
                            if (a.accounts_managed < b.accounts_managed) {
                                return 1;
                            }
                            return 0;
                        }
                    )
                });
            } else {
                store.dispatch({
                    type: SET_ACCOUNT_MANAGERS,
                    payload: []
                });
            }
        })
        .catch((e) => e && console.error(e));
    }

    render() {
        return (
            <DataTable
                title={"Account Managers"}
                data={
                    this.props.accountManagers
                        .map(acm => [acm.id, <UserImage {...acm} />, (acm.name + (acm.surname ? " " + acm.surname : "")), acm.accounts_managed])
                }
                columns={columns}
                options={this.options}
            />
        );
    }
}

const mapStateToProps = (state) => ({ accountManagers: state.allUsers.accountManagers })

export default connect(mapStateToProps)(AccountManagers);